import { Dependencies } from "../../models"

export interface Survey {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string;
    },
    descriptions: {
        [key: string]: string;
    },
    imageUrl: string
    link: string
    startDate: Date
    endDate: Date
    dependencies: Dependencies
}

export interface SurveyListItem {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string;
    },
    descriptions: {
        [key: string]: string;
    },
    imageUrl: string
    link: string
    startDate: Date
    endDate: Date
}

export interface PagedSurvey {
    items: SurveyListItem[]
    totalCount: number
}

export const SURVEY_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    descriptions: "Opis",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    image: "Slika",
    link: "Link",
    startDate: "Datum početka",
    endDate: "Datum završetka",
    dependencies: "Ovisnosti",
}
